module.exports = __webpack_public_path__ + "static/media/barbell.ad38fa36.png";